import React, { useEffect, useState } from "react";
import { clientApi } from "../lib/api";
import { motion } from "framer-motion";
import { TrendingUp, Building2, Thermometer, Users } from "lucide-react";

const fmtBRL = (n) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 }).format(n || 0);
const fmtInt = (n) => new Intl.NumberFormat("pt-BR").format(n || 0);

export default function RadarOrulo() {
  const [data, setData] = useState(null);
  const [city, setCity] = useState("");

  const load = () => clientApi.get("/orulo", { params: { city: city || undefined } }).then(({ data }) => setData(data)).catch(() => setData(null));
  useEffect(() => { load(); }, []);

  const d = data?.data;

  return (
    <div className="space-y-6" data-testid="cliente-orulo-page">
      <div className="flex flex-wrap justify-between items-end gap-4">
        <div>
          <div className="text-xs uppercase tracking-widest text-accent-orange mb-1">Radar de Mercado</div>
          <h1 className="font-display text-3xl md:text-4xl">Órulo · Inteligência de Lançamentos {data?.source === "demo" && <span className="text-xs text-neutral-500 lowercase tracking-widest">(demo)</span>}</h1>
          <p className="text-sm text-neutral-400 mt-2">Dados de mercado — empreendimentos lançados, absorção, preço médio, principais incorporadoras.</p>
        </div>
        <div className="flex gap-2 items-end">
          <div>
            <label className="text-[10px] uppercase tracking-widest text-neutral-500">Cidade/UF</label>
            <input value={city} onChange={(e) => setCity(e.target.value)} placeholder="Goiânia/GO" className="bg-black border border-white/10 rounded-lg px-3 py-2 text-sm mt-1" />
          </div>
          <button onClick={load} className="bg-accent-orange text-white text-xs font-bold px-4 py-2.5 rounded-full">Consultar</button>
        </div>
      </div>

      {d && (
        <div className="grid md:grid-cols-3 gap-4">
          <Card icon={Building2} label="Lançamentos (12m)" value={fmtInt(d.buildings_launched_12m)} accent="text-blue-400" />
          <Card icon={TrendingUp} label="Preço médio m²" value={fmtBRL(d.avg_price_per_sqm)} accent="text-accent-orange" />
          <Card icon={Thermometer} label="Absorção média" value={`${d.avg_absorption_rate}%`} accent="text-green-400" />
        </div>
      )}

      {d?.top_developers && (
        <div className="border border-white/10 rounded-xl p-6 bg-white/[0.02]">
          <div className="text-xs uppercase tracking-widest text-accent-orange mb-4 flex items-center gap-2"><Users className="w-3 h-3" /> Principais Incorporadoras</div>
          <div className="space-y-2">
            {d.top_developers.map((dev, i) => (
              <div key={i} className="flex justify-between items-center border-b border-white/5 pb-2 last:border-0">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-accent-orange text-black flex items-center justify-center font-bold text-xs">{i + 1}</div>
                  <span className="font-semibold">{dev.name}</span>
                </div>
                <span className="text-sm text-neutral-400"><b className="text-white">{dev.buildings}</b> empreendimentos</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="text-[11px] text-neutral-500 text-center border-t border-white/5 pt-4">
        Integração <b>Órulo API</b> · aguardando chave em <span className="text-accent-orange">/admin/client-integrations</span> para ativar dados reais.
      </div>
    </div>
  );
}

function Card({ icon: Icon, label, value, accent }) {
  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="border border-white/10 rounded-xl p-5 bg-white/[0.02]">
      <div className={`w-9 h-9 rounded-lg bg-black/40 flex items-center justify-center mb-3 ${accent}`}><Icon className="w-4 h-4" /></div>
      <div className="text-[10px] uppercase tracking-widest text-neutral-500 mb-1">{label}</div>
      <div className="font-display text-3xl">{value}</div>
    </motion.div>
  );
}
